export const switchThemeMode = (mode: string) => {
  if (typeof document === 'undefined') {
    return null;
  }
  const modeOff = mode === 'light' ? 'dark' : 'light';

  document.documentElement.classList.add(mode);
  document.documentElement.classList.remove(modeOff);
};
